// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body.driver-active .patient-log-drawer.ant-drawer-open,
body.driver-active .patient-log-drawer.ant-drawer-open .ant-drawer-mask,
body.driver-active .patient-log-drawer.ant-drawer-open .ant-drawer-content-wrapper {
  z-index: 10001 !important;
}

body.driver-active .patient-log-drawer .driver-active-element,
body.driver-active .patient-log-drawer .driver-active-element-parent {
  z-index: 10002 !important;
}

body.driver-active .patient-log-button.driver-active-element {
  z-index: 10002 !important;
}

.clinic-onboarding-popover {
  max-width: 360px;
}

.clinic-onboarding-popover .driver-popover-title {
  font-size: 16px;
  font-weight: 600;
}

.clinic-onboarding-popover .driver-popover-description {
  font-size: 14px;
  line-height: 1.6;
}

[dir='rtl'] .clinic-onboarding-popover {
  direction: rtl;
  text-align: right;
}

[dir='rtl'] .clinic-onboarding-popover .driver-popover-footer {
  flex-direction: row-reverse;
}
`, "",{"version":3,"sources":["webpack://./src/onboarding/onboarding.css"],"names":[],"mappings":"AAAA;;;EAGE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":["body.driver-active .patient-log-drawer.ant-drawer-open,\nbody.driver-active .patient-log-drawer.ant-drawer-open .ant-drawer-mask,\nbody.driver-active .patient-log-drawer.ant-drawer-open .ant-drawer-content-wrapper {\n  z-index: 10001 !important;\n}\n\nbody.driver-active .patient-log-drawer .driver-active-element,\nbody.driver-active .patient-log-drawer .driver-active-element-parent {\n  z-index: 10002 !important;\n}\n\nbody.driver-active .patient-log-button.driver-active-element {\n  z-index: 10002 !important;\n}\n\n.clinic-onboarding-popover {\n  max-width: 360px;\n}\n\n.clinic-onboarding-popover .driver-popover-title {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.clinic-onboarding-popover .driver-popover-description {\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n[dir='rtl'] .clinic-onboarding-popover {\n  direction: rtl;\n  text-align: right;\n}\n\n[dir='rtl'] .clinic-onboarding-popover .driver-popover-footer {\n  flex-direction: row-reverse;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
